import { EZarucenieEmise } from 'enums/isin/udaje/zarucenieEmise';

const zarucenieEmiseSelect = [
    {
        value: EZarucenieEmise.ST,
        labelcz: 'ISIN_EMISE_WARRANT_ZARUCENI_ST'
    },
    {
        value: EZarucenieEmise.JS,
        labelcz: 'ISIN_EMISE_WARRANT_ZARUCENI_JS'
    },
    {
        value: EZarucenieEmise.HZL,
        labelcz: 'ISIN_EMISE_WARRANT_ZARUCENI_HZL'
    },
    {
        value: EZarucenieEmise.BEZ,
        labelcz: 'ISIN_EMISE_WARRANT_ZARUCENI_BEZ'
    }
];

export const zarucenieEmiseSelectAlt = [
    {
        value: EZarucenieEmise.VZ,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_VZ'
    },
    {
        value: EZarucenieEmise.SZ,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_SZ'
    },
    {
        value: EZarucenieEmise.ZA,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_Z'
    },
    {
        value: EZarucenieEmise.NE,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_NEZ'
    },
    {
        value: EZarucenieEmise.NZ,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_NZ'
    },
    {
        value: EZarucenieEmise.SE,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_S'
    },
    {
        value: EZarucenieEmise.NA,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_NA'
    }
];
export const zarucenieEmisePodrizenySelect = [
    {
        value: EZarucenieEmise.SP,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_SP'
    },
    {
        value: EZarucenieEmise.JU,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_J'
    },
    {
        value: EZarucenieEmise.JP,
        labelcz: 'ISIN_EMISE_DLUHOPIS_ZARUCENI_JP'
    }
];

export default zarucenieEmiseSelect;
